module.exports = __webpack_public_path__ + "img/0.6de6f405.png";